import { LocalStorageKey } from "../consts/local-storage-key";

export function removeLocalStorageAuthData() {
  localStorage.removeItem(LocalStorageKey.Token);
  localStorage.removeItem(LocalStorageKey.RefreshToken);
  localStorage.removeItem(LocalStorageKey.TokenValidTo);
  localStorage.removeItem(LocalStorageKey.RefreshTokenValidTo);
  localStorage.removeItem(LocalStorageKey.User);
}
